import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { NewsItem } from '../types';

interface NewsContextType {
  news: NewsItem[];
  addNews: (item: Omit<NewsItem, 'id'>) => void;
  deleteNews: (id: number) => void;
}

const NewsContext = createContext<NewsContextType | undefined>(undefined);

const INITIAL_NEWS: NewsItem[] = [
  { id: 1, date: "Dec 02, 2025", title: "New Eco-Friendly Packaging Launch", content: "We are excited to announce our transition to 100% biodegradable materials starting next month.", type: 'success' },
  { id: 2, date: "Nov 20, 2025", title: "Community Pet Walk Event", content: "Join us at Central Park this Sunday for a charity walk supporting local shelters.", type: 'info' }
];

export const NewsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [news, setNews] = useState<NewsItem[]>(() => {
    const saved = localStorage.getItem('natuvia_news');
    return saved ? JSON.parse(saved) : INITIAL_NEWS;
  });

  useEffect(() => {
    localStorage.setItem('natuvia_news', JSON.stringify(news));
  }, [news]);

  const addNews = (item: Omit<NewsItem, 'id'>) => {
    const newItem = { ...item, id: Date.now() };
    setNews(prev => [newItem, ...prev]);
  };

  const deleteNews = (id: number) => {
    setNews(prev => prev.filter(n => n.id !== id));
  };

  return (
    <NewsContext.Provider value={{ news, addNews, deleteNews }}>
      {children}
    </NewsContext.Provider>
  );
};

export const useNews = () => {
  const context = useContext(NewsContext);
  if (!context) throw new Error('useNews must be used within NewsProvider');
  return context;
};